module.exports = "/img/logo.svg?0e1faec962fb176076529897fbd237c7";